import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { HelperService } from '../../services/helper.service';
import { NotificationBuilder } from '../notificationBuilder';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { AdministratorService } from '../../administrator/administrator.service';

@Component({
    selector: 'hire-feature',
    templateUrl: './hire-feature.component.html',
})

export class HireFeatureComponent implements OnInit {
    @Input() featureId: string
    @Input() description: string
    @Input() name: string
    @Output() answer = new EventEmitter();

    constructor(private helperService: HelperService, public changeDetection: ChangeDetectorRef, private adminService: AdministratorService, private notificationBuilder: NotificationBuilder, public ngxSmartModalService: NgxSmartModalService) {
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        console.log('destroy');
    }

    ngOnChanges() {
        if (this.featureId != null) {
            console.log('ticket: ' + this.featureId)
            //this.openTicket()
        }
    }

}

